import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText, { ITextVariants } from '@ui/atoms/BasicText';

import { ColorTypes, FontSizeTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface IStyledPill {
	color: ColorTypes;
	padding?: FontSizeTypes;
}

export interface IPillProps extends IStyledPill {
	title: string;
	className?: string;
	variant?: ITextVariants;
}

const StyledPill = styled.div<IStyledPill>`
	border-radius: ${theme.radius.xl};
	background: ${({ color }) => theme.colors[color]};
	min-width: 8rem;
	padding: ${({ padding = 'smmd' }) => `0.6rem ${theme.spacing[padding]}`};
	text-align: center;
	width: fit-content;

	& > ${BasicText} {
		line-height: 1;
	}
`;

const Pill: FC<IPillProps> = ({ className, color, padding = 'sm', title, variant = 'pill' }) => {
	return (
		<StyledPill color={color} className={className} padding={padding}>
			<BasicText variant={variant}>{title}</BasicText>
		</StyledPill>
	);
};

export default styled(Pill)``;
